import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { NotificationDetailsFragmentDoc } from '../../fragments/generated/NotificationDetails';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetNotificationQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.UserNotificationsFilters>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
}>;


export type GetNotificationQuery = { userNotifications: { success: boolean, totalCount: number, edges?: Array<{ __typename: 'UserNotificationPayloadEdge', node: { id: string, createdAt: string, message: string, icon?: string | null, redirectPath: string, status: Types.UserNotificationStatusEnum, userProfileIcon?: string | null, type: Types.NotificationActionTypeEnum, quotedMessage?: string | null } }> | null, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null } };


export const GetNotificationDocument = /*#__PURE__*/ gql`
    query getNotification($filters: UserNotificationsFilters, $first: Float, $after: String, $sort: [SortType!]) {
  userNotifications(sort: $sort, filters: $filters, first: $first, after: $after) {
    success
    totalCount
    edges {
      node {
        ...NotificationDetails
      }
      __typename
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${NotificationDetailsFragmentDoc}`;

export function useGetNotificationQuery(options?: Omit<Urql.UseQueryArgs<GetNotificationQueryVariables>, 'query'>) {
  return Urql.useQuery<GetNotificationQuery, GetNotificationQueryVariables>({ query: GetNotificationDocument, ...options });
};